import { matchPath, useLocation } from 'react-router-dom'

export function useIsPath(paths: string[]) {
  const location = useLocation()
  const currentPage = location.pathname
  const matchesCurrentPage = (element: string) => !!matchPath(currentPage, { path: element, exact: true })

  return paths.some(matchesCurrentPage)
}
